<!-- eslint-disable max-len -->
<template>
    <div>
      <dropin-container style="margin-bottom: 10px;" ref="dropinContainer" @loaded="onMethodChange" @payment-method-changed="onMethodChange" />
      <button
        style="position: absolute; bottom: 40px; right: 40px; width: 150px; z-index: 1000;"
        class="btn"
        :disabled="!paymentMethodReady"
        @click="selectPaymentMethod()">
          Select Payment Method
      </button>
    </div>
</template>

<script>
import DropinContainer from '../DropinContainer';

export default {
  components: {
    DropinContainer,
  },
  props: {
    course: Object
  },
  computed: {
    paymentMethodReady() {
      if (this.paymentMethodFlip && !this.paymentMethodFlip) { const ex = {}; throw ex; }
      if (this.$refs.dropinContainer) {
        return this.$refs.dropinContainer.dropin.isPaymentMethodRequestable();
      }
      return false;
    }
  },
  data() {
    return {
      couponCode: '',
      activeCouponData: {
        isActive: false,
        discount: 0
      },
      paymentMethodFlip: false
    };
  },
  methods: {
    onMethodChange() {
      this.paymentMethodFlip = !this.paymentMethodFlip;
    },
    async selectPaymentMethod() {
      if (!this.$refs.dropinContainer) return;

      const dropin = this.$refs.dropinContainer.dropin;
      if (!dropin) return;

      const method = await dropin.requestPaymentMethod();
      this.$emit('payment-method-selected', method);
      return method;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/braintree/purchase-flow-views/PaymentPage.vue